// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d30cd055","455":"49ae2b55","977":"aef734ff"}[chunkId] + ".chunk.js";
};